import React, { memo, useCallback, useEffect, useMemo, useState } from 'react';
import { AutoComplete, Form } from 'antd';
import LeftSideMenu from '../LeftSideMenu';
import Page from '../Page';
import PageNavigation from '../PageNavigation';
import './Report.less';
import { getReportStores, IStore } from '@ui/api/v2/store.api';
import { Store } from './Store';
import { LoadableContent } from '@ui/components';
import { transformFormatSource } from '@ui/tools/transformSource';
import { StoreState } from '@ui/store/rootReducer';
import { metaSelectors } from '@ui/store/meta';
import { connect } from 'react-redux';
import { IMarket } from '@ui/api/v2/markets.api';
import { ICity } from '@ui/api/v2/cities.api';
import { IRegion } from '@ui/api/v2/regions.api';

const { Item } = Form;

interface IProps {
  markets: IMarket[];
  cities: ICity[];
  regions: IRegion[];
}

function checkId(id?: string) {
  if (!id) {
    return true;
  }
  const n = Number(id);
  return Boolean(n && !isNaN(n));
}

function Report({ cities, markets, regions }: IProps) {
  const [loading, setLoading] = useState(false);
  const [stores, setStores] = useState<IStore[]>([]);

  const [regionId, setRegionId] = useState<string>();
  const [cityId, setCityId] = useState<string>();
  const [marketId, setMarketId] = useState<string>();

  const fetchStores = useCallback(async () => {
    if (checkId(regionId) && checkId(cityId) && checkId(marketId)) {
      setLoading(true);
      const { data } = await getReportStores(regionId, cityId, marketId);
      if (data) {
        setStores(data);
      }
      setLoading(false);
    }
  }, [regionId, cityId, marketId]);

  useEffect(() => {
    void fetchStores();
  }, [fetchStores]);

  const regionsSource = useMemo(() => transformFormatSource(regions), [regions]);
  const citiesSource = useMemo(
    () => transformFormatSource(cities.filter((c) => (regionId ? c.region.id === Number(regionId) : true))),
    [cities, regionId],
  );
  const marketsSource = useMemo(
    () => transformFormatSource(markets.filter((m) => (cityId ? m.city.id === Number(cityId) : true))),
    [markets, cityId],
  );

  return (
    <div className="report">
      <PageNavigation title="Отчет" />
      <Page>
        <Page.LeftSide>
          <LeftSideMenu className="report__left-side" topPanel="Поиск">
            <div className="report__form">
              <Item label="Регион">
                <AutoComplete
                  style={{ width: '100%' }}
                  value={regionId}
                  onSelect={(v) => setRegionId(v as string)}
                  onChange={(v) => setRegionId(v as string)}
                  allowClear
                  dataSource={regionsSource}
                  size="large"
                />
              </Item>
              <Item label="Город">
                <AutoComplete
                  style={{ width: '100%' }}
                  value={cityId}
                  onSelect={(v) => setCityId(v as string)}
                  onChange={(v) => setCityId(v as string)}
                  allowClear
                  dataSource={citiesSource}
                  size="large"
                />
              </Item>
              <Item label="ТЦ">
                <AutoComplete
                  style={{ width: '100%' }}
                  value={marketId}
                  onSelect={(v) => setMarketId(v as string)}
                  onChange={(v) => setMarketId(v as string)}
                  allowClear
                  dataSource={marketsSource}
                  size="large"
                />
              </Item>
            </div>
          </LeftSideMenu>
        </Page.LeftSide>
        <Page.Content>
          <LoadableContent loading={loading}>
            <div className="report__wrapper">
              {stores.map((s) => (
                <Store key={s.id} store={s} />
              ))}
            </div>
          </LoadableContent>
        </Page.Content>
      </Page>
    </div>
  );
}

const mapStateToProps = (state: StoreState) => ({
  cities: metaSelectors.getCities(state),
  markets: metaSelectors.getMarkets(state),
  regions: metaSelectors.getRegions(state),
});

export default connect(mapStateToProps)(memo(Report));



// WEBPACK FOOTER //
// ./src/components/Report/Report.tsx